import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { getProjectKeyOrId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-or-id/index.tsx';
import { QUERY } from './gql.tsx';

const RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS = 'AI_FIRST_CREATE_FIELDS';

type AIFirstCreateResourceResponse =
	| {
			data: {
				jiraIssueCreateFields: {
					fields: {
						nodes: [];
					};
					errors: [];
				};
			};
	  }
	| undefined;

const getAIFirstCreateResource = async (
	projectId: string,
): Promise<AIFirstCreateResourceResponse> => {
	try {
		const response = await performPostRequest('/rest/gira/1/', {
			body: JSON.stringify({
				query: QUERY,
				variables: {
					projectId,
					withNumberFormat: true,
					issueType: null,
				},
			}),
		});
		return response;
	} catch (error) {
		return undefined;
	}
};

export const aiFirstCreateResource: RouteResource<AIFirstCreateResourceResponse> = createResource({
	type: RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS,
	getKey: ({ query }) => `${RESOURCE_TYPE_AI_FIRST_CREATE_FIELDS}:${query.projectKey}`,
	getData: async ({ match }: RouterDataContext, _storeContext: ResourceStoreContext) => {
		const projectKeyOrId = getProjectKeyOrId(match);
		if (!projectKeyOrId) {
			return undefined;
		}

		return getAIFirstCreateResource(projectKeyOrId);
	},
	isBrowserOnly: true,
	isCritical: true,
	maxAge: 0,
	maxCache: 0,
});

export const useAIFirstCreateResource =
	(): UseResourceHookResponse<AIFirstCreateResourceResponse> => useResource(aiFirstCreateResource);
